/**
 * @file コンポーネント：フル動画ページダイジェスト動画 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { RavnurPlayer } from "~/src/components/uiparts/RavnurPlayer";

// スタイル読み込み
import { StyledPlayer } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledPlayer>
            {props.isLoaded && (
                <>
                    <RavnurPlayer
                        fairplayCer={props.fairplayCer}
                        fairplayLaUrl={props.fairplayLaUrl}
                        hasAudio={props.hasAudio}
                        mediaId="digest"
                        movieUrl={props.movieUrl}
                        playreadyLaUrl={props.playreadyLaUrl}
                        setMediaPlayer={props.setMediaPlayerDigestvideo}
                        widevineLaUrl={props.widevineLaUrl}
                        operationId={props.operationId}
                    />
                </>
            )}
        </StyledPlayer>
    );
};
